/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
import { url } from 'utils/urls';
// material
import { SingleSelectDropDown } from '@insticator/insticator-ui'
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './contentalignment_styles'

const contenAlignmentOptionList = [
  { name: 'Centered', option: 'Centered', value: 'CENTERED'},
  { name: 'Left', option: 'Left', value: 'LEFT'},
  { name: 'Right', option: 'Right', value: 'RIGHT'},
]

const contentAlignmentOption = {
  'CENTERED': contenAlignmentOptionList[0],
  'LEFT': contenAlignmentOptionList[1],
  'RIGHT': contenAlignmentOptionList[2]
}

const contentAlignmentPreview = {
  'CENTERED': 'content-alignment-preview-center.png',
  'LEFT': 'content-alignment-preview-left.png',
  'RIGHT': 'content-alignment-preview-right.png'
}

/* ========== ~~~~~~~~~~ ARTICLE SENTIMENT CONFIG V2: GENERAL SECTION : CONTENT ALIGNMENT ~~~~~~~~~~ ========== */
const ContentAlignment = injectSheet(styles)((props) => {

  const { contentAlignment, onChange } = props

  const handleContentAlignmentChange = opt => onChange({ contentAlignment: opt.value })


  return (
    <Space gap={48} justifyContent={'space-between'} klass={`contentalignment ${props.classes.contentalignment}`} > 
      <SectionGroupV2 
        indented={true} 
        title={'Content Alignment'} 
        description={'Control how your unit is positioned on the page and the title alignment.'}
        rowGap={32} 
        direction={'column'}
      >
        <SingleSelectDropDown 
          name={`${contentAlignmentOption[contentAlignment].name}`} 
          searchable={false} 
          onSelect={handleContentAlignmentChange}
          items={contenAlignmentOptionList}
        />
    </SectionGroupV2>
    <PreviewConfig>
      <img src={`${url.image}/2.0/articlesentiment/general/${contentAlignmentPreview[contentAlignment]}`} alt=""  />
    </PreviewConfig>
  </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ContentAlignment;